var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.copyright)}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.beian)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }